import { render, staticRenderFns } from "./BackHome.vue?vue&type=template&id=2223bc4c&scoped=true&"
import script from "./BackHome.vue?vue&type=script&lang=js&"
export * from "./BackHome.vue?vue&type=script&lang=js&"
import style0 from "./BackHome.vue?vue&type=style&index=0&id=2223bc4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2223bc4c",
  null
  
)

export default component.exports